(function () {
  'use strict';

  var context = window.MOOD_PAGE_CONTEXT || {};
  var recent = new Map();

  function clean(value) {
    if (value == null) return value;
    if (Array.isArray(value)) return value.map(clean);
    if (typeof value !== 'object') return value;
    var result = {};
    Object.keys(value).forEach(function (key) {
      if (/^(email|phone|address|first_name|last_name|full_name|customer_name)$/i.test(key)) return;
      result[key] = clean(value[key]);
    });
    return result;
  }

  function publish(name, data) {
    var payload = clean(data || {});
    var fingerprint = name + ':' + JSON.stringify(payload);
    var now = Date.now();
    if (recent.has(fingerprint) && now - recent.get(fingerprint) < 750) return;
    recent.set(fingerprint, now);
    if (recent.size > 80) {
      recent.forEach(function (time, key) {
        if (now - time > 10000) recent.delete(key);
      });
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    document.documentElement.dataset.moodEventLast = name;
    document.documentElement.dataset.moodEventCount = String(Number(document.documentElement.dataset.moodEventCount || 0) + 1);
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      try { Shopify.analytics.publish(name, payload); } catch (error) {}
    }
  }

  window.MOOD_EVENTS = { publish: publish };
  document.documentElement.dataset.moodMeasurement = 'ready';

  function productItem() {
    var product = window.MOOD_SHOPIFY_PRODUCT;
    if (!product) return null;
    var variant = product.variants && product.variants.find(function (item) { return item.available; });
    variant = variant || (product.variants && product.variants[0]);
    return {
      item_id: product.handle,
      item_name: product.title,
      item_brand: 'MOOD',
      item_variant: variant && variant.title,
      price: variant && variant.price ? variant.price / 100 : undefined,
      currency: product.currency || context.currency
    };
  }

  function initialise() {
    var item = productItem();
    if (item) publish('view_item', { ecommerce: { currency: item.currency, value: item.price, items: [item] } });

    if (context.pageType === 'blog') publish('view_item_list', { item_list_id: 'mood_journal', item_list_name: 'MOOD Journal' });
    if (context.pageType === 'collection') publish('view_item_list', { item_list_id: context.handle || 'all', item_list_name: context.title || 'All products' });
    if (context.pageType === 'search' && context.searchPerformed) publish('view_search_results', { search_term: context.searchTerms || '', results_count: context.searchResults || 0 });

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (link) {
        var href = link.getAttribute('href') || '';
        if (href.indexOf('/products/') === 0) publish('select_item', { destination: href, source: location.pathname });
        if (href.indexOf('/blogs/') === 0 && context.pageType === 'blog') publish('mood_journal_article_click', { destination: href });
        if (href === '/checkout') publish('begin_checkout', { source: location.pathname });
      }

      var packageCard = event.target.closest('#mood-purchase-selector .mood-ps-card');
      if (packageCard && !packageCard.classList.contains('is-unavailable')) {
        var radio = packageCard.querySelector('input[type="radio"]');
        publish('mood_pack_selected', {
          product: context.handle,
          variant_id: packageCard.dataset.variantId || (radio && radio.value),
          package_label: (packageCard.querySelector('.mood-ps-title') || {}).textContent || ''
        });
      }

      var xsell = event.target.closest('.mood-xsell-card,a[href*="/products/mood-"]');
      if (xsell && xsell.closest('#xsell,.xsell,.mood-xsell')) publish('mood_xsell_click', { destination: xsell.getAttribute('href') || '' });
    });

    document.addEventListener('toggle', function (event) {
      if (event.target.matches('details') && event.target.open) {
        publish('mood_faq_open', { label: (event.target.querySelector('summary') || {}).textContent || '' });
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form.matches('form[role="search"],form[action*="/search"]')) publish('search', { search_term: (form.querySelector('input[type="search"]') || {}).value || '' });
      if (form.matches('.mood-shell-newsletter,.mood-newsletter-form,form[action*="/contact"]') && form.querySelector('input[type="email"]')) publish('generate_lead', { lead_type: 'newsletter' });
      if (form.matches('.mood-contact-form')) publish('generate_lead', { lead_type: 'contact' });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
